const CounterUpPlugin = {
    init: ($) => {
        const delay = $(this).attr('data-delay') ? $(this).attr('data-delay') : 100; //default is 100
        const time = $(this).attr('data-time') ? $(this).attr('data-time') : 1200; //default is 1200

        $('[data-plugin="counterup"]').each(function () {
            $(this).counterUp({
                delay: delay,
                time: time,
            });
        });
    },
};

export default CounterUpPlugin;
